import { useMutation, useQueryClient } from '@tanstack/react-query';
import { adminUsersApi } from '../api/admin-users.api';
import type { CreateAdminUserRequest } from '../types/admin-user.types';
import { adminUserKeys } from './queryKeys';
import { Notification } from '@/shared/components/ahkinia/Notification/notification';

/**
 * React Query hook to create a new admin user
 * Invalidates: ['adminUsers'] queries on success
 */
export const useCreateAdminUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateAdminUserRequest) => adminUsersApi.createUser(data),
    onSuccess: () => {
      // Invalidate all admin users queries to refetch the list
      queryClient.invalidateQueries({ queryKey: adminUserKeys.all });
      Notification.success({
        title: 'Administrador creado',
        description:
          'El nuevo administrador ha sido creado exitosamente. Se ha enviado un correo electrónico con instrucciones para configurar la contraseña.',
      });
    },
  });
};
